import {NgModule} from '@angular/core';
import {APOLLO_OPTIONS, Apollo} from 'apollo-angular';
import {ApolloLink, InMemoryCache} from '@apollo/client/core';
import {HttpLink} from 'apollo-angular/http';
import {environment} from '../../environments/environment';
import {ImageCropComponent} from './modals/image-crop/image-crop.component';
import {ImageCropperModule} from 'ngx-image-cropper';
import {ContentDisplayComponent} from './modals/content-display/content-display.component';
import {CommonModule} from '@angular/common';
import {ContentDeleteComponent} from './modals/content-delete/content-delete.component';
import {ReactiveFormsModule} from '@angular/forms';
import {UserDeleteComponent} from './modals/user-delete/user-delete.component';
import {PasswordProtectComponent} from './modals/password-protect/password-protect.component';
import {ArchiveTemplateComponent} from './modals/archive-template/archive-template.component';
import {MultiSelectComponent} from './components/multi-select/multi-select.component';
import {ConfirmationComponent} from './modals/confirmation/confirmation.component';
import {TagLabelTitleComponent} from './modals/tag-label-title/tag-label-title.component';
import {EditTemplateLabelsComponent} from './modals/edit-template-labels/edit-template-labels.component';
import {EditTemplateTagsComponent} from './modals/edit-template-tags/edit-template-tags.component';
import {TemplateCopyComponent} from './modals/template-copy/template-copy.component';

const uri = environment.host + 'graphql';

export function createApollo(httpLink: HttpLink): {cache: InMemoryCache; link: ApolloLink} {
  const http = httpLink.create({uri});

  return {
    link: ApolloLink.from([
      // new SentryLink({
      //   setFingerprint: false,
      //   setTransaction: false,
      //   shouldHandleOperation: undefined,
      //   uri,
      //   attachBreadcrumbs: {
      //     includeError: true,
      //     includeQuery: true,
      //     includeVariables: true
      //   }
      // }),
      http,
    ]),
    cache: new InMemoryCache(),
  };
}

@NgModule({
  providers: [
    Apollo,
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink],
    },
  ],
  declarations: [
    ImageCropComponent,
    ContentDisplayComponent,
    ContentDeleteComponent,
    UserDeleteComponent,
    PasswordProtectComponent,
    ArchiveTemplateComponent,
    MultiSelectComponent,
    ConfirmationComponent,
    TagLabelTitleComponent,
    EditTemplateLabelsComponent,
    EditTemplateTagsComponent,
    TemplateCopyComponent,
  ],
  imports: [ImageCropperModule, CommonModule, ReactiveFormsModule],
  exports: [MultiSelectComponent],
})
export class GraphQLModule {}
